/*
 * Copyright (c) 2026 Talent Catalog.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE. See the GNU General Public License
 * for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see https://www.gnu.org/licenses/.
 */

import {Component, Input, OnInit} from '@angular/core';
import {Candidate, CandidateIntakeData} from '../../../../model/candidate';
import {CandidateDependantService} from '../../../../services/candidate-dependant.service';
import {Country} from "../../../../model/country";

@Component({
  selector: 'app-dependants',
  templateUrl: './dependants.component.html',
  styleUrls: ['./dependants.component.scss']
})
export class DependantsComponent implements OnInit {

  @Input() candidate: Candidate;
  @Input() candidateIntakeData: CandidateIntakeData;
  @Input() editable: boolean = true;
  error: boolean;
  @Input() nationalities: Country[];
  saving: boolean;
  open: boolean;

  constructor(
    private candidateDependantService: CandidateDependantService
  ) {}

  ngOnInit(): void {
  }

  deleteRecord(i: number) {
    this.candidateIntakeData?.candidateDependants.splice(i, 1);
  }

}
